import React from "react";
import "../BlockChain/Blockchain.css";
import "./MobleAppDevelopment.css";
import { NavLink } from "react-router-dom";
import {
  FiArrowRight,
  FiSmartphone,
  FiLayout,
  FiActivity,
  FiSearch,
  FiCode,
  FiTool,
} from "react-icons/fi";

const AppCrad = [
  {
    id: 1,
    icon: <FiSearch />,
    title: "Mobile App Consulting",
    dis: "Expert consulting to shape your idea. We assess business needs, target audience, and implement high-velocity mobile strategies.",
  },
  {
    id: 2,
    icon: <FiLayout />,
    title: "UX & UI Design",
    dis: "Crafting wireframes and high-fidelity prototypes that validate your concept before full-scale engineering begins.",
  },
  {
    id: 3,
    icon: <FiSmartphone />,
    title: "iOS & Android",
    dis: "Meticulously crafted native applications that align with platform-specific human interface guidelines for optimal UX.",
  },
  {
    id: 4,
    icon: <FiCode />,
    title: "Cross-Platform",
    dis: "Leveraging React Native and Flutter to build high-performance applications from a single, robust codebase.",
  },
  {
    id: 5,
    icon: <FiActivity />,
    title: "Automated QA",
    dis: "Rigorous testing processes to identify and resolve potential bottlenecks, guaranteeing a 60fps fluid user experience.",
  },
  {
    id: 6,
    icon: <FiTool />,
    title: "Maintenance",
    dis: "Post-launch support ensuring your infrastructure remains secure and compatible with the latest OS ecosystem updates.",
  },
];

const MobleAppDevelopment = () => {
  return (
    <div className="sub-service-page mobileapp-page">
      <div className="page-bg-engine">
        <div className="theme-orb orb-primary"></div>
        <div className="theme-orb orb-secondary"></div>
      </div>
      {/* --- Section 1: Sovereign Hero --- */}
      <section className="sub-hero">
        <div className="v2-container">
          <div className="sub-hero-content">
            <div className="v3-badge">Mobile Innovation</div>
            <h1 className="title-reveal">
              Building Native <span className="blue-glow">Excellence</span>
            </h1>
            <p className="v3-hero-p-centered">
              Combining top-notch programming skills with creative expertise to
              design fluid, high-velocity native and hybrid mobile applications.
            </p>
          </div>
        </div>
      </section>

      {/* --- Section 2: Intro --- */}
      <section className="sub-content-section">
        <div className="v2-container">
          <div className="content-layout-left">
            <h2 className="v3-title">
              Human-Centered <span className="blue-glow">Performance</span>
            </h2>
            <p className="v3-p-text">
              XpertHouse Tech provides exceptional mobile app development
              services. We strive to create progressive web apps that deliver
              consistent and reliable performance across all global markets.
            </p>

            <div className="tech-stack-strip">
              <img src="/andro1.webp" alt="Android" />
              <img src="/andro2.webp" alt="iOS" />
              <img src="/andro3.webp" alt="React" />
              <img src="/andro4.webp" alt="Flutter" />
              <img src="/andro5.webp" alt="Kotlin" />
              <img src="/andro6.webp" alt="Swift" />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 3: App Services Grid --- */}
      <section className="sub-features-section">
        <div className="v2-container">
          <div className="v3-section-head left">
            <h2 className="v3-title">
              Our <span className="blue-glow">Engineering</span> Capabilities
            </h2>
          </div>

          <div className="feature-grid-sub">
            {AppCrad.map((item) => (
              <div className="feature-card-sub" key={item.id}>
                <div className="f-icon-box">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.dis}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- Section 4: Technical Deep Dive --- */}
      <section className="sub-platforms">
        <div className="v2-container">
          <div className="platform-row">
            <div className="platform-text">
              <h2 className="v3-title">
                Native <span className="blue-glow">iOS</span> Stacks
              </h2>
              <p className="v3-p-text">
                We use Swift & Objective-C to develop native iOS apps that are
                fast, responsive, and beautiful, utilizing the latest SDK
                features.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Technical Inquiry <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <img src="/mob3.jpg" alt="iOS Dev" />
            </div>
          </div>

          <div className="platform-row reverse">
            <div className="platform-text">
              <h2 className="v3-title">
                Native <span className="blue-glow">Android</span> Stacks
              </h2>
              <p className="v3-p-text">
                Leveraging Kotlin and Java to build reliable, material-design
                oriented applications optimized for the global Android
                ecosystem.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Initialize Build <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <img src="/mob2.jpg" alt="Android Dev" />
            </div>
          </div>

          <div className="platform-row">
            <div className="platform-text">
              <h2 className="v3-title">
                Hybrid <span className="blue-glow">Ecosystems</span>
              </h2>
              <p className="v3-p-text">
                Save resources with React Native and Flutter. We develop one
                robust codebase that targets both iOS and Android
                simultaneously.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Consult Experts <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <img src="/mob1.jpg" alt="Hybrid Dev" />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 5: Universal CTA --- */}
      <section className="v3-final-cta">
        <div className="v2-container">
          <div className="v3-cta-card">
            <div className="v3-cta-content">
              <h2 className="v3-cta-title">
                Ready to build <br />
                <span className="grad-blue">your next app?</span>
              </h2>
              <NavLink to="/contactus" className="v3-main-btn">
                <span>Initialize Discovery</span>
                <div className="btn-icon-box">
                  <FiArrowRight />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MobleAppDevelopment;
